import { t } from "@lingui/macro";
import { deleto, get, patch, post, puto } from 'bukku/shared/ApiService';
import { all, call, delay, fork, put, select, take, takeEvery } from 'bukku/shared/SagaService';
import queryString from "query-string";
import { flowDigestItems, flowDigestItemsPagination, useDummyDigestItems } from "../../containers/AppPage/ControlPanel/Flow/dummy/flowDigestItems";
import { flowDigestOrderItems, useDummyDigestOrderItems } from "../../containers/AppPage/ControlPanel/Flow/dummy/flowDigestOrderItems";
import { flowDigestOrders, flowDigestOrdersPagination, useDummyDigestOrders } from "../../containers/AppPage/ControlPanel/Flow/dummy/flowDigestOrders";
import { flowDigestSummary, useDummyDigestSummary } from "../../containers/AppPage/ControlPanel/Flow/dummy/flowDigestSummary";
import { flowDigests, flowDigestsPagination, useDummyFlowDigests } from "../../containers/AppPage/ControlPanel/Flow/dummy/flowDigests";
import { flowProviders, useDummyFlowProviders } from '../../containers/AppPage/ControlPanel/Flow/dummy/flowProviders';
import { flowStreamLazada, flowStreamStorehub, useDummyFlowStream } from "../../containers/AppPage/ControlPanel/Flow/dummy/flowStream";
import { flowStreamMappingsNew, flowStreamMappingsView, useDummyStreamMappings } from "../../containers/AppPage/ControlPanel/Flow/dummy/flowStreamMappings";
import { flowStreams, flowStreamsPagination, useDummyFlowStreams } from "../../containers/AppPage/ControlPanel/Flow/dummy/flowStreams";
import { errorSagaFn, requestSagaPullingFn, requestSagaPushingFn, successSagaFn } from "../helper";
import { store } from '../store';
import actions from './actions';
import { FlowProviderName } from "../../containers/AppPage/ControlPanel/Flow/enums/FlowProviderName";
import { getBulkDigestSuccessMsg, normalizeStreamToListApiStream } from "./helper";
import ListActions from 'bukku/redux/List/actions';
import _ from "underscore";

// const apiUrl = process.env.REACT_APP_API_URL;

const successKeys = [
    actions.FLOW_READ_ALL_PROVIDERS_SUCCESS,
    actions.FLOW_CONNECT_OAUTH2_SUCCESS,
    actions.FLOW_READ_ALL_STREAMS_SUCCESS,
    actions.FLOW_READ_STREAM_SUCCESS,
    actions.FLOW_READ_STREAM_MAPPING_SUCCESS,
    actions.FLOW_CREATE_HTTP_STREAM_SUCCESS,
    actions.FLOW_UPDATE_STREAM_SUCCESS,
    actions.FLOW_UPDATE_STREAM_MAPPINGS_SUCCESS,
    actions.FLOW_SYNCHRONIZE_STREAM_SUCCESS,
    actions.FLOW_DEACTIVATE_STREAM_SUCCESS,
    actions.FLOW_ACTIVATE_STREAM_SUCCESS,
    actions.FLOW_DELETE_STREAM_SUCCESS,
    actions.FLOW_READ_ALL_DIGESTS_SUCCESS,
    actions.FLOW_BULK_DELETE_DIGESTS_SUCCESS,
    actions.FLOW_BULK_POSTING_SUCCESS,
    actions.FLOW_POST_DIGEST_TO_INVOICE_SUCCESS,
    actions.FLOW_DELETE_DIGEST_SUCCESS,

    // actions.FLOW_READ_DIGEST_SUMMARY_SUCCESS,
    // actions.FLOW_READ_DIGEST_ITEMS_SUCCESS,
    // actions.FLOW_READ_DIGEST_ORDERS_SUCCESS,
    // actions.FLOW_READ_DIGEST_ORDER_ITEMS_SUCCESS,
];
const errorKeys = [
    actions.FLOW_READ_ALL_PROVIDERS_ERROR,
    actions.FLOW_CONNECT_OAUTH2_ERROR,
    actions.FLOW_READ_ALL_STREAMS_ERROR,
    actions.FLOW_READ_STREAM_ERROR,
    actions.FLOW_READ_STREAM_MAPPING_ERROR,
    actions.FLOW_CREATE_HTTP_STREAM_ERROR,
    actions.FLOW_UPDATE_STREAM_ERROR,
    actions.FLOW_UPDATE_STREAM_MAPPINGS_ERROR,
    actions.FLOW_SYNCHRONIZE_STREAM_ERROR,
    actions.FLOW_DEACTIVATE_STREAM_ERROR,
    actions.FLOW_ACTIVATE_STREAM_ERROR,
    actions.FLOW_DELETE_STREAM_ERROR,
    actions.FLOW_READ_ALL_DIGESTS_ERROR,
    actions.FLOW_BULK_DELETE_DIGESTS_ERROR,
    actions.FLOW_BULK_POSTING_ERROR,
    actions.FLOW_POST_DIGEST_TO_INVOICE_ERROR,
    actions.FLOW_DELETE_DIGEST_ERROR,
    actions.FLOW_UPDATE_STREAM_MAPPINGS_ERROR,
    // actions.FLOW_READ_DIGEST_SUMMARY_ERROR,
    // actions.FLOW_READ_DIGEST_ITEMS_ERROR,
    // actions.FLOW_READ_DIGEST_ORDERS_ERROR,
    // actions.FLOW_READ_DIGEST_ORDER_ITEMS_ERROR,
];

const getSuccessMsg = action => {
    const { type } = action; // { data, type }
    switch (type) {
        case actions.FLOW_CREATE_HTTP_STREAM_SUCCESS:
            return t`Stream created, please update the mappings before you can post to invoice.`;
        case actions.FLOW_UPDATE_STREAM_SUCCESS:
            return t`Stream updated.`;
        case actions.FLOW_UPDATE_STREAM_MAPPINGS_SUCCESS:
            return t`Mappings updated.`;
        case actions.FLOW_DEACTIVATE_STREAM_SUCCESS:
            return t`Stream deactivated.`;
        case actions.FLOW_ACTIVATE_STREAM_SUCCESS:
            return t`Stream activated.`;
        case actions.FLOW_DELETE_STREAM_SUCCESS:
            return t`Stream disconnected.`;
        case actions.FLOW_SYNCHRONIZE_STREAM_SUCCESS:
            return t`The sync is scheduled and you will be notified when it's done.`;
        case actions.FLOW_BULK_DELETE_DIGESTS_SUCCESS: {
            const { success_count, fail_count } = action;
            return getBulkDigestSuccessMsg('deleted', success_count, fail_count);
        }
        case actions.FLOW_BULK_POSTING_SUCCESS:
            return t`You will receive a notification when the bulk posting has completed.`;
        case actions.FLOW_POST_DIGEST_TO_INVOICE_SUCCESS:
            return t`Digest has been posted.`;
        case actions.FLOW_DELETE_DIGEST_SUCCESS:
            return t`Digest is deleted.`;
        default:
            return null;
    }
};

const getRedirectUrl = (providerId, flowStreamId) => {
    const { Auth } = store.getState();
    const { subdomain, accessToken } = Auth;
    // const url = `${apiUrl}/flow/providers/${providerId}/oauth/authorise`;
    const url = `/flow/providers/${providerId}/oauth/authorise`;

    const params = {
        flow_stream_id: flowStreamId || undefined,
        cs: subdomain,
        token: accessToken,
    };
    const paramsString = queryString.stringify(params,
        { arrayFormat: 'bracket', skipNull: true, sort: false },
    );

    if (paramsString)
        return `${url}?${paramsString}`;

    return url;
};
/* PROVIDERS */
export function* readAllProvidersRequest() {
    yield takeEvery(actions.FLOW_READ_ALL_PROVIDERS_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* () {
                if (useDummyFlowProviders) {
                    yield delay(100);
                    // OK
                    yield put({
                        type: actions.FLOW_READ_ALL_PROVIDERS_SUCCESS,
                        providers: flowProviders,
                    });
                }
                else {
                    const response = yield call(get, '/flow/providers', null, context);
                    const data = yield response.data;

                    // OK
                    yield put({
                        type: actions.FLOW_READ_ALL_PROVIDERS_SUCCESS,
                        providers: data.providers,
                    });
                }
            });
    });
}

export function* connectOauth2Request() {
    yield takeEvery(actions.FLOW_CONNECT_OAUTH2_REQUEST, function* (action) {
        yield requestSagaPullingFn(action,
            function* ({providerId, flowStreamId}) {
                // yield window.location.replace(getRedirectUrl(id));
                // Using window.open, clicking back page will bring back to page calling the redirection (ie Flow page).
                // window.location.replace will bring back to the 2nd previous page, ie the page before calling the redirection.
                // yield window.open(getRedirectUrl(id), '_self');
                const response = yield call(get, getRedirectUrl(providerId, flowStreamId));
                const data = yield response.data;
                window.open(data.redirect_link, '_self');
            });
    });
}

// export function* connectHttpRequest() {
//     yield takeEvery(actions.FLOW_CONNECT_HTTP_REQUEST, function* (action, context) {
//         yield requestSagaPushingFn(action,
//             function* ({ request }) {
//                 const response = yield call(post, '/flow/streams', request, context);
//                 const data = yield response.data;

//                 // OK
//                 yield put({
//                     type: actions.FLOW_CREATE_HTTP_STREAM_SUCCESS,
//                     stream: data.stream,
//                 });
//             });
//     });
// }

/* STREAMS */
export function* readAllStreamsRequest() {
    yield takeEvery(actions.FLOW_READ_ALL_STREAMS_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ request }) {
                // const useDummyBankFeeds = BankFeedUseDummy[actions.BANK_FEED_READ_ALL_REQUEST];
                // let data;
                // if (!useDummyBankFeeds) {
                //     const response = yield call(get, '/bank_feeds', payload, context);
                //     data = yield response.data;
                // }
                // else {
                //     yield delay(1000);
                //     data = {
                //         bank_feeds: BankFeedDummyDatas[action.type],
                //     };
                // }

                if (useDummyFlowStreams) {
                    yield delay(100);
                    // OK
                    yield put({
                        type: actions.FLOW_READ_ALL_STREAMS_SUCCESS,
                        streams: flowStreams,
                        pagination: flowStreamsPagination,
                    });
                }
                else {
                    const response = yield call(get, '/flow/streams', request, context);
                    const data = yield response.data;

                    // OK
                    yield put({
                        type: actions.FLOW_READ_ALL_STREAMS_SUCCESS,
                        streams: data.streams,
                        pagination: data.paging,
                    });
                }
            });
    });
}

export function* readStreamRequest() {
    yield takeEvery(actions.FLOW_READ_STREAM_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ streamId }) {
                if (useDummyFlowStream) {
                    const dummyFlowStream = {
                        [FlowProviderName.lazada]: flowStreamLazada,
                        [FlowProviderName.storehub]: flowStreamStorehub,
                    };

                    yield delay(100);
                    // OK
                    yield put({
                        type: actions.FLOW_READ_STREAM_SUCCESS,
                        stream: dummyFlowStream[useDummyFlowStream] || [],
                    });
                }
                else {
                    const response = yield call(get, `/flow/streams/${streamId}`, null, context);
                    const data = yield response.data;

                    // OK
                    yield put({
                        type: actions.FLOW_READ_STREAM_SUCCESS,
                        stream: data.stream,
                    });
                }
            });
    });
}

export function* readStreamMappingRequest() {
    yield takeEvery(actions.FLOW_READ_STREAM_MAPPING_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ streamId }) {
                if (useDummyStreamMappings) {
                    const dummyStreamMappings = {
                        new: flowStreamMappingsNew,
                        view: flowStreamMappingsView,
                    };

                    yield delay(100);
                    // OK
                    yield put({
                        type: actions.FLOW_READ_STREAM_MAPPING_SUCCESS,
                        mappings: dummyStreamMappings[useDummyStreamMappings] || [],
                    });
                }
                else {
                    const response = yield call(get, `/flow/streams/${streamId}/mappings`, null, context);
                    const data = yield response.data;

                    // OK
                    yield put({
                        type: actions.FLOW_READ_STREAM_MAPPING_SUCCESS,
                        mappings: data,
                    });
                }
            });
    });
}

export function* createHttpStreamRequest() {
    yield takeEvery(actions.FLOW_CREATE_HTTP_STREAM_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ request }) {
                const response = yield call(post, '/flow/streams', request, context);
                const data = yield response.data;
                const {stream} = data;

                // OK
                yield put({
                    type: actions.FLOW_CREATE_HTTP_STREAM_SUCCESS,
                    stream,
                });

                // After done creating, add to List Api so that it will show in sidebar / global search
                yield put({
                    type: ListActions.LIST_ADD_FLOW_STREAM,
                    flowStream: normalizeStreamToListApiStream(stream),
                });
            });
    });
}

export function* updateStreamRequest() {
    yield takeEvery(actions.FLOW_UPDATE_STREAM_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ streamId, request }) {
                const response = yield call(puto, `/flow/streams/${streamId}`, request, context);
                const data = yield response.data;

                // OK
                yield put({
                    type: actions.FLOW_UPDATE_STREAM_SUCCESS,
                    stream: data.stream,
                });
            });
    });
}

export function* updateStreamMappingsRequest() {
    yield takeEvery(actions.FLOW_UPDATE_STREAM_MAPPINGS_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ streamId, request }) {
                const response = yield call(puto, `/flow/streams/${streamId}/mappings`, request, context);
                const data = yield response.data;

                // OK
                yield put({
                    type: actions.FLOW_UPDATE_STREAM_MAPPINGS_SUCCESS,
                    mappingData: data,
                });
            });
    });
}

export function* synchronizeStreamRequest() {
    yield takeEvery(actions.FLOW_SYNCHRONIZE_STREAM_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ streamId }) {
                yield call(post, `/flow/streams/${streamId}/sync`, null, context);

                // OK
                yield put({
                    type: actions.FLOW_SYNCHRONIZE_STREAM_SUCCESS,
                });
            });
    });
}

export function* deactivateStreamRequest() {
    yield takeEvery(actions.FLOW_DEACTIVATE_STREAM_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ streamId }) {
                const response = yield call(patch, `/flow/streams/${streamId}/deactivate`, null, context);
                const data = yield response.data;
                const { stream } = data;

                // OK
                yield put({
                    type: actions.FLOW_DEACTIVATE_STREAM_SUCCESS,
                    stream,
                });

                // Update ListApi so that it will be removed in sidebar / global search
                const { flowStreams } = yield select(state => state.List);
                const newStreams = flowStreams.filter(s => s.id !== streamId);

                yield put({
                    type: ListActions.LIST_CHANGE_FLOW_STEAMS,
                    flowStreams: newStreams,
                });
            });
    });
}

export function* activateStreamRequest() {
    yield takeEvery(actions.FLOW_ACTIVATE_STREAM_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ streamId }) {
                const response = yield call(patch, `/flow/streams/${streamId}/activate`, null, context);
                const data = yield response.data;
                const { stream } = data;

                // OK
                yield put({
                    type: actions.FLOW_ACTIVATE_STREAM_SUCCESS,
                    stream,
                });

                // Update ListApi so that it will be added in sidebar / global search sorted by id
                const { flowStreams } = yield select(state => state.List);
                let newStreams = [
                    ...flowStreams,
                    normalizeStreamToListApiStream(stream),
                ];
                newStreams = _.sortBy(newStreams, 'id');

                yield put({
                    type: ListActions.LIST_CHANGE_FLOW_STEAMS,
                    flowStreams: newStreams,
                });
            });
    });
}

export function* deleteStreamRequest() {
    yield takeEvery(actions.FLOW_DELETE_STREAM_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ streamId }) {
                const response = yield call(deleto, `/flow/streams/${streamId}`, null, context);
                const data = yield response.data;

                // OK
                yield put({
                    type: actions.FLOW_DELETE_STREAM_SUCCESS,
                    stream: data.stream,
                });

                // Update ListApi so that it will be removed in sidebar / global search
                const { flowStreams } = yield select(state => state.List);
                const newStreams = flowStreams.filter(s => s.id !== streamId);

                yield put({
                    type: ListActions.LIST_CHANGE_FLOW_STEAMS,
                    flowStreams: newStreams,
                });
            });
    });
}

/* STREAMS */
export function* readAllDigestsRequest() {
    yield takeEvery(actions.FLOW_READ_ALL_DIGESTS_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ request, streamId }) {
                if (useDummyFlowDigests) {
                    yield delay(100);
                    // OK
                    yield put({
                        type: actions.FLOW_READ_ALL_DIGESTS_SUCCESS,
                        digests: flowDigests,
                        pagination: flowDigestsPagination,
                        request,
                    });
                }
                else {
                    const response = yield call(get, `/flow/streams/${streamId}/digests`, request, context);
                    const data = yield response.data;

                    // OK
                    yield put({
                        type: actions.FLOW_READ_ALL_DIGESTS_SUCCESS,
                        digests: data.digests,
                        pagination: data.paging,
                        request,
                    });
                }
            });
    });
}

export function* deleteDigestRequest() {
    yield takeEvery(actions.FLOW_DELETE_DIGEST_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ streamId, digestId, request, refetchList }) {
                yield call(deleto, `/flow/streams/${streamId}/digests/${digestId}`, null, context);

                // OK
                yield put({
                    type: actions.FLOW_DELETE_DIGEST_SUCCESS,
                });

                // After done deleting, fetch digests again if required
                if (refetchList || request?.refetchList) {
                    const { lastDigestsReadAllRequest } = yield select(state => state.Flow);
                    yield put(actions.readAllDigests(streamId, lastDigestsReadAllRequest));
                }
            });
    });
}

export function* bulkDeleteDigestsRequest() {
    yield takeEvery(actions.FLOW_BULK_DELETE_DIGESTS_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ request, streamId }) {
                if (useDummyFlowDigests) {
                    yield delay(100);
                    // OK
                    // yield put({
                    //     count: request.length,
                    //     // type: actions.FLOW_BULK_DELETE_DIGESTS_SUCCESS,
                    // });

                    // After done delete, fetch digests again
                    const { lastDigestsReadAllRequest } = yield select(state => state.Flow);
                    yield put(
                        actions.readAllDigests(streamId, lastDigestsReadAllRequest),
                    );
                    yield take([actions.FLOW_READ_ALL_DIGESTS_SUCCESS, actions.FLOW_READ_ALL_DIGESTS_ERROR]);
                    yield put({
                        success_count: request.length,
                        fail_count: 0,
                        type: actions.FLOW_BULK_DELETE_DIGESTS_SUCCESS,
                    });
                }
                else {
                    const response = yield call(post, `/flow/streams/${streamId}/digests/bulk_delete`, request, context);
                    const { success_count, fail_count } = yield response.data;

                    // After done delete, fetch digests again
                    const { lastDigestsReadAllRequest } = yield select(state => state.Flow);
                    yield put(actions.readAllDigests(streamId, lastDigestsReadAllRequest));
                    yield take([actions.FLOW_READ_ALL_DIGESTS_SUCCESS, actions.FLOW_READ_ALL_DIGESTS_ERROR]);

                    yield put({
                        type: actions.FLOW_BULK_DELETE_DIGESTS_SUCCESS,
                        success_count,
                        fail_count,
                    });
                }
            });
    });
}

export function* bulkPostDigestsRequest() {
    yield takeEvery(actions.FLOW_BULK_POSTING_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ request, streamId }) {
                yield call(post, `/flow/streams/${streamId}/digests/bulk_posting`, request, context);
                // const data = yield response.data;

                // OK
                yield put({
                    type: actions.FLOW_BULK_POSTING_SUCCESS,
                });
            });
    });
}

export function* postDigestToInvoiceRequest() {
    yield takeEvery(actions.FLOW_POST_DIGEST_TO_INVOICE_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ streamId, digestId, request, refetchList }) {
                const response = yield call(post, `/flow/streams/${streamId}/digests/${digestId}/invoice`, null, context);
                const data = yield response.data;
                // OK
                yield put({
                    type: actions.FLOW_POST_DIGEST_TO_INVOICE_SUCCESS,
                    postedDigestInvoice: data,
                });

                // After done posting, fetch digests again if required
                if (refetchList || request?.refetchList) {
                    const { lastDigestsReadAllRequest } = yield select(state => state.Flow);
                    yield put(actions.readAllDigests(streamId, lastDigestsReadAllRequest));
                }
                // if (refetchPayout || request?.refetchPayout)
                //     yield put(actions.lazada.readPayout());
            });
    });
}

export function* readDigestSummaryRequest() {
    yield takeEvery(actions.FLOW_READ_DIGEST_SUMMARY_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ streamId, digestId }) {
                if (useDummyDigestSummary) {
                    yield delay(100);
                    yield put({
                        type: actions.FLOW_READ_DIGEST_SUMMARY_SUCCESS,
                        digestSummary: flowDigestSummary,
                    });
                }
                else {
                    const response = yield call(get, `/flow/streams/${streamId}/digests/${digestId}`, null, context);
                    const data = yield response.data;
                    // OK
                    yield put({
                        type: actions.FLOW_READ_DIGEST_SUMMARY_SUCCESS,
                        digestSummary: data.digest,
                    });
                }
            });
    });
}

export function* readDigestItemsRequest() {
    yield takeEvery(actions.FLOW_READ_DIGEST_ITEMS_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ request, streamId, digestId }) {
                if (useDummyDigestItems) {
                    yield delay(100);
                    // OK
                    yield put({
                        type: actions.FLOW_READ_DIGEST_ITEMS_SUCCESS,
                        digestItems: flowDigestItems,
                        pagination: flowDigestItemsPagination,
                    });
                }
                else {
                    const response = yield call(get, `/flow/streams/${streamId}/digests/${digestId}/items`, request, context);
                    const data = yield response.data;

                    // OK
                    yield put({
                        type: actions.FLOW_READ_DIGEST_ITEMS_SUCCESS,
                        digestItems: data.items,
                        pagination: data.paging,
                    });
                }
            });
    });
}

export function* readDigestOrdersRequest() {
    yield takeEvery(actions.FLOW_READ_DIGEST_ORDERS_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ request, streamId, digestId }) {
                if (useDummyDigestOrders) {
                    yield delay(100);
                    // OK
                    yield put({
                        type: actions.FLOW_READ_DIGEST_ORDERS_SUCCESS,
                        digestOrders: flowDigestOrders,
                        pagination: flowDigestOrdersPagination,
                    });
                }
                else {
                    const response = yield call(get, `/flow/streams/${streamId}/digests/${digestId}/orders`, request, context);
                    const data = yield response.data;

                    // OK
                    yield put({
                        type: actions.FLOW_READ_DIGEST_ORDERS_SUCCESS,
                        digestOrders: data.orders,
                        pagination: data.paging,
                    });
                }
            });
    });
}

export function* readDigestOrderItemsRequest() {
    yield takeEvery(actions.FLOW_READ_DIGEST_ORDER_ITEMS_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ request, streamId, digestId, orderId }) {
                if (useDummyDigestOrderItems) {
                    yield delay(100);
                    // OK
                    yield put({
                        type: actions.FLOW_READ_DIGEST_ORDER_ITEMS_SUCCESS,
                        digestOrderItems: parseInt(orderId, 10) === 0 ? [flowDigestOrderItems[0]] :
                            [flowDigestOrderItems[1], flowDigestOrderItems[2]],
                        orderId,
                    });
                }
                else {
                    const response = yield call(get, `/flow/streams/${streamId}/digests/${digestId}/orders/${orderId}/items`, request, context);
                    const data = yield response.data;

                    // OK
                    yield put({
                        type: actions.FLOW_READ_DIGEST_ORDER_ITEMS_SUCCESS,
                        digestOrderItems: data,
                        orderId,
                    });
                }
            });
    });
}

export default function* rootSaga() {
    yield all([
        fork(successSagaFn(successKeys, getSuccessMsg)),
        fork(errorSagaFn(errorKeys)),

        // PROVIDERS
        fork(readAllProvidersRequest),
        fork(connectOauth2Request),
        // fork(connectHttpRequest),

        // STREAMS
        fork(readAllStreamsRequest),
        fork(readStreamRequest),
        fork(readStreamMappingRequest),
        fork(createHttpStreamRequest),
        fork(updateStreamRequest),
        fork(updateStreamMappingsRequest),
        fork(synchronizeStreamRequest),
        fork(deactivateStreamRequest),
        fork(activateStreamRequest),
        fork(deleteStreamRequest),

        // DIGESTS
        fork(readAllDigestsRequest),
        fork(deleteDigestRequest),
        fork(bulkDeleteDigestsRequest),
        fork(bulkPostDigestsRequest),
        fork(postDigestToInvoiceRequest),
        fork(readDigestSummaryRequest),
        fork(readDigestItemsRequest),
        fork(readDigestOrdersRequest),
        fork(readDigestOrderItemsRequest),
    ]);
}
